var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2068 12.0976C44.2068 10.5819 44.9844 9.77546 46.0894 9.77546C47.208 9.77546 47.9446 10.5263 47.9446 11.8334C47.9446 12.6955 47.6172 13.5854 46.7169 14.0999L44.2204 15.4209V12.0976H44.2068ZM61.2725 12.8902C59.7583 12.4174 58.7488 12.2088 58.7488 11.0825C58.7488 10.1926 59.39 9.67812 60.5904 9.67812C61.9 9.67812 63.0868 10.0675 64.1782 10.6376C64.3692 10.7349 64.5601 10.6515 64.5874 10.4568L64.9558 6.82761C64.9694 6.64685 64.9012 6.4939 64.7238 6.42437C63.4961 5.9238 62.0364 5.57617 60.2903 5.57617C56.1296 5.57617 53.9469 7.73143 53.9469 11.1242C53.9469 14.1694 55.7204 15.5738 59.1853 16.5332C60.5904 16.9782 61.0952 17.3258 61.0952 18.3131C61.0952 19.2725 60.4949 19.8565 59.2126 19.8565C57.5347 19.8565 55.7476 19.0639 54.2607 18.174C54.0015 18.0211 53.8105 18.1462 53.8105 18.3965V22.2065C53.8105 22.4567 53.8787 22.6236 54.1516 22.7766C55.352 23.4579 57.18 24.0002 59.4582 24.0002C63.346 24.0002 65.8697 21.9284 65.8697 18.2157C65.8697 14.9898 64.1373 13.7801 61.2725 12.8902ZM52.0371 18.1601C50.9185 18.8693 49.4043 19.5923 47.4399 19.5923C46.826 19.5923 46.1166 19.4672 45.7619 19.2586L49.1587 17.4927C51.205 16.3525 52.4873 14.809 52.4873 12.0002C52.4873 11.8334 52.4873 11.3467 52.4873 11.166C52.4464 8.12077 49.9636 5.59008 46.1712 5.59008C41.8741 5.59008 39.2549 8.21811 39.2549 12.5008V17.0894C39.2549 19.0222 39.9506 20.5657 40.8782 21.6085C42.2288 23.1242 44.3159 24.0002 46.8124 24.0002C49.2542 24.0002 51.0003 23.5413 52.2145 22.7766C52.3782 22.6653 52.5282 22.5124 52.5146 22.2065V18.3965C52.4873 18.1323 52.269 18.0072 52.0371 18.1601Z",
    fill: "#253746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6644 22.0113C38.9823 21.0797 38.5048 20.1063 38.232 18.8688C38.1911 18.6741 37.9865 18.5768 37.8091 18.6741C36.6359 19.2998 35.9266 19.4806 35.2445 19.2998C34.5624 19.1191 34.1532 18.4238 34.1532 17.1724V9.96964H37.2089C37.3589 9.96964 37.4681 9.8445 37.4681 9.70545V6.04845C37.4681 5.8955 37.3453 5.78426 37.2089 5.78426H34.1532V0.347434C34.1532 0.19448 34.0304 0.0693359 33.894 0.0693359H29.4195C29.2694 0.0693359 29.1603 0.180575 29.1603 0.347434V5.78426H26.8412C26.6912 5.78426 26.582 5.9094 26.582 6.04845V9.69154C26.582 9.8445 26.7048 9.95574 26.8412 9.95574H29.1603V18.4655C29.1603 22.6926 31.5476 23.9719 34.1395 23.9719C36.3085 23.9719 38.1092 23.374 39.5825 22.4563C39.719 22.3728 39.7599 22.1504 39.6644 22.0113Z",
    fill: "#253746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 0.305664V0.33317C8.49315 0.33317 8.49315 0.33317 8.5068 0.33317L8.47949 0.305664Z",
    fill: "#D0DF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81445 20.5659C5.12405 21.7895 6.72013 22.6934 8.4799 23.1939V17.7988L3.81445 20.5659Z",
    fill: "#002E5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6991 23.6522H13.4316V20.7461L9.01172 23.3463C9.87114 23.541 10.7715 23.6522 11.6991 23.6522Z",
    fill: "#EF426F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4316 23.6525H18.3699L13.4316 20.7324V23.6525Z",
    fill: "#002E5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 23.2074C8.65683 23.263 8.82053 23.3047 8.99788 23.3464L13.4178 20.7462L8.47949 17.8262V23.2074V23.2074Z",
    fill: "#0092C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4793 17.8124L3.54102 14.9062V20.3014C3.63651 20.3848 3.71836 20.4821 3.81385 20.5656L8.4793 17.8124Z",
    fill: "#00C7B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.130859 12.876C0.239993 14.1274 0.526467 15.3232 0.976642 16.4217L3.55492 14.9061L0.130859 12.876Z",
    fill: "#753BBD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 17.8124L13.4314 20.7324V14.9062L8.47949 17.8124Z",
    fill: "#D0DF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4316 20.7325L18.3699 23.6526V17.8125L13.4316 20.7325Z",
    fill: "#00C7B1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.322 23.6525V20.7324L18.3701 23.6525H23.322Z",
    fill: "#753BBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 23.6526L23.322 20.7325L18.3701 17.8125V23.6526Z",
    fill: "#0092C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4316 20.7324L18.3699 17.8124L13.4316 14.9062V20.7324Z",
    fill: "#002E5D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 11.9727V17.8127L13.4314 14.9066L8.47949 11.9727Z",
    fill: "#EF426F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54102 9.06641V14.9065L8.4793 11.9725L3.54102 9.06641Z",
    fill: "#D0DF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54089 3.22559C2.36771 4.4075 1.44008 5.85362 0.839844 7.45268L3.55453 9.06565V3.22559H3.54089Z",
    fill: "#0092C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4314 14.9065V9.06641L8.47949 11.9725L13.4314 14.9065Z",
    fill: "#0092C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3699 17.8127V11.9727L13.4316 14.9066L18.3699 17.8127Z",
    fill: "#753BBD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.322 20.7324V14.9062L18.3701 17.8124L23.322 20.7324Z",
    fill: "#002E5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 17.8127L23.322 14.9066L18.3701 11.9727V17.8127Z",
    fill: "#EF426F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54102 3.22559V9.06565L8.4793 6.14562L3.54102 3.22559Z",
    fill: "#753BBD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4314 3.22559L8.47949 6.14562L13.4314 9.06565V3.22559Z",
    fill: "#EF426F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4316 9.06554L18.3699 11.9717V6.14551L13.4316 9.06554Z",
    fill: "#002E5D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 11.9719L23.3084 14.892V11.7633C23.3084 10.8873 23.2129 10.0252 23.0492 9.21875L18.3701 11.9719Z",
    fill: "#753BBD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 11.9724L23.0492 9.21924C23.0219 9.108 22.9946 8.98286 22.9674 8.87162L18.3701 6.16016V11.9724Z",
    fill: "#0092C8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3699 6.14562L13.4316 3.22559V9.06565L18.3699 6.14562Z",
    fill: "#D0DF00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4314 3.22644L8.50678 0.320312C8.49313 0.320312 8.49313 0.320312 8.47949 0.320312V6.14647L13.4314 3.22644Z",
    fill: "#D0DF00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9673 8.85768C22.599 7.27252 21.9169 5.84031 21.0029 4.58887L18.3564 6.14622L22.9673 8.85768Z",
    fill: "#002E5D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 1.98828V6.14585L21.0166 4.5885C20.2799 3.57344 19.3932 2.71134 18.3701 1.98828Z",
    fill: "#00C7B1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9648 1.1402C15.8871 0.584007 14.7003 0.208574 13.4316 0V3.21204L16.9648 1.1402Z",
    fill: "#753BBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesLogo);
export default __webpack_public_path__ + "static/media/tes_logo.4a368662045952f0260e5205625db453.svg";
export { ForwardRef as ReactComponent };